var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/CaptiveWindow/Footer/Footer.tsx",
  _this = this;
import React, { useContext } from 'react';
import './footer.scss';
import { Box } from '@wds/box';
import getFooterLinks from './getFooterLinks';
import { StaticContext } from '../../StaticContext';
var Footer = function Footer() {
  var _useContext = useContext(StaticContext),
    languageCode = _useContext.environment.languageCode;
  return /*#__PURE__*/React.createElement(Box, {
    element: "footer",
    display: "flex",
    className: "sm-captive-footer",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    p: 2,
    m: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 7
    }
  }, getFooterLinks(languageCode).map(function (linkData) {
    return /*#__PURE__*/React.createElement("a", {
      key: linkData.href,
      className: "sm-captive-footer__link",
      href: linkData.href,
      rel: "noopener noreferrer",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 11
      }
    }, linkData.text);
  }), /*#__PURE__*/React.createElement("a", {
    href: "#cookiePreferences",
    className: "ot-sdk-show-settings",
    "data-testid": "CaptiveFooterLinks__cookiePreferences",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  })));
};
export default Footer;
//# sourceMappingURL=Footer.js.map